// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_QqO","cls2":"Search-cls2_sqP Search-cls1_QqO"};